import { render } from "./MovieSlider.vue?vue&type=template&id=0960ee00&scoped=true"
import script from "./MovieSlider.vue?vue&type=script&lang=js"
export * from "./MovieSlider.vue?vue&type=script&lang=js"

import "./MovieSlider.vue?vue&type=style&index=0&id=0960ee00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0960ee00"]])

export default __exports__